import { render, staticRenderFns } from "./CadastroPeriferico.vue?vue&type=template&id=207121c8"
import script from "./CadastroPeriferico.vue?vue&type=script&lang=js"
export * from "./CadastroPeriferico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports